import { useContext } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import UserContext from "../../context/user";

const useBorseRequestDeleteMutation = () => {
  const { callApi, userProfile } = useContext(UserContext);
  const queryClient = useQueryClient();

  return useMutation(
    ({ campaignId, request }) =>
      callApi(`/scholarship/request/${campaignId}/${request?.id}`, {
        method: "DELETE",
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["requests", JSON.stringify(userProfile)]);
      },
    }
  );
};

export default useBorseRequestDeleteMutation;
